const helpers = {
  /**
* Returns generic ['development', 'staging', 'production'] value
* @param {String} env from VUE_APP_ENVIRONMENT based on build configuration
* @returns ['development', 'staging', 'production']
*/
  getGenericEnvironment: function getGenericEnvironment() {
    const env = process.env.VUE_APP_ENVIRONMENT
    switch (env) {
      case 'production':
      case 'i18n-production':
        return 'production'
      case 'staging-uk':
      case 'ieng-staging':
        return 'staging'
      case 'qa9':
      case 'qa11':
      default:
        return 'development'
    }
  },
  /**
   * Converts JavaScript types to String,
   * incl. `null` and `undefined`
   *
   * @param {Any} type to be converted to String
   */
  typeToString: type => {
    let stringValue = ''

    switch (typeof type) {
      case 'object':
        stringValue = JSON.stringify(type)
        break
      case 'symbol':
        stringValue = type.toString()
        break
      default:
        stringValue = `${type}`
    }

    return stringValue
  },
  /**
   * @param {String} phoneNumber as link property and link text
   * @returns HTML Phone Link representation
   */
  phoneNumberHtmlLink: phoneNumber => (phoneNumber && `<a href="tel:${phoneNumber}">${phoneNumber}</a>`) || null
}

export default helpers
